import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';

const TopicSentimentRadar = ({ data }) => {
    const [option, setOption] = useState({});

    useEffect(() => {
        const handleThemeChange = () => {
            setOption(createTopicSentimentRadarOption(data));
        };

        handleThemeChange();

        const media = window.matchMedia('(prefers-color-scheme: dark)');
        media.addEventListener('change', handleThemeChange);

        return () => media.removeEventListener('change', handleThemeChange);
    }, [data]);

    const createTopicSentimentRadarOption = (topics) => {
        const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

        const topicNames = topics.map(t => t.topic.charAt(0).toUpperCase() + t.topic.slice(1));

        const maxFrequency = Math.max(...topics.map(t => t.frequency));
        const radarIndicators = topicNames.map((name, i) => ({
            name,
            max: maxFrequency + 5 // Padding
        }));

        return {
            tooltip: {
                trigger: 'item'
            },
            legend: {
                top: 10,
                data: ['Frequency', 'Sentiment'],
                textStyle: {
                    color: isDark ? '#eee' : '#666'
                }
            },
            radar: {
                radius: '65%',
                indicator: radarIndicators,
                name: {
                    textStyle: {
                        color: isDark ? '#eee' : '#333'
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: isDark ? '#444' : '#ccc'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: isDark ? ['#444'] : ['#ccc']
                    }
                },
                splitArea: {
                    areaStyle: {
                        color: isDark ? ['#222'] : ['#fff']
                    }
                }
            },
            series: [
                {
                    name: 'Topic Metrics',
                    type: 'radar',
                    data: [
                        {
                            value: topics.map(t => t.frequency),
                            name: 'Frequency',
                            areaStyle: { opacity: 0.2 },
                            itemStyle: { color: '#3b82f6' },
                            lineStyle: { color: '#3b82f6' }
                        },
                        {
                            value: topics.map(t => (t.sentiment_score + 1) * (maxFrequency / 2)), // Normalize sentiment to frequency scale
                            name: 'Sentiment',
                            areaStyle: { opacity: 0.2 },
                            itemStyle: { color: '#ef4444' },
                            lineStyle: { color: '#ef4444' }
                        }
                    ]
                }
            ]
        };
    };


    return (
        <ReactECharts
            option={option}
            notMerge={true}
            lazyUpdate={true}
            style={{ height: '400px', width: '100%' }}
        />
    );
};

export default TopicSentimentRadar;
